export enum TicketsType {
    All = 1,
    Category = 2,
    Redirected = 3
}